import type { TrainingModule } from "@/services/training-services";

/** Whether finishing a guided-tour training must run the module's quiz first.
 *
 *  Mirrors the regular player's predicate (training-page.tsx): an attached,
 *  unpassed quiz gates the finish — regardless of prior completion, since
 *  `complete_module` 409s while the quiz is unpassed even on a module the
 *  learner already completed. Under the two-axis completion model a quiz
 *  attached after completion also reopens the module on the learner's path
 *  ("new material added") until they pass; a pass is permanent — no edit or
 *  retake can un-pass it. */
export function quizPending(
  mod: Pick<TrainingModule, "quiz">,
): boolean {
  return mod.quiz != null && mod.quiz.question_count > 0 && !mod.quiz.passed;
}
